import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { UnifiedSidebar } from "./unified-sidebar";
import { SidebarProvider, useSidebar } from "@/components/ui/sidebar";
import AIChatAgent from "@/components/ai-chat-agent";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import NotFound from "@/pages/NotFound";
import { getAppFromPathname } from "@/utils/app-route.utils";
import { getRouteWayfinding } from "@/utils/document-title.utils";

const SIDEBAR_WIDTH = 400;

function MobileHeader() {
  const { setMobileOpen, mobileOpen } = useSidebar();
  const { pathname } = useLocation();
  const { pageTitle, appName } = getRouteWayfinding(pathname);

  const toggleSidebar = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <div className="lg:hidden fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 px-4 py-2.5">
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="sm"
          onClick={toggleSidebar}
          className="p-2 shrink-0"
          aria-label={mobileOpen ? "Close menu" : "Open menu"}
        >
          {mobileOpen ? (
            <X className="h-5 w-5" />
          ) : (
            <Menu className="h-5 w-5" />
          )}
        </Button>
        <div className="min-w-0 flex-1 text-center">
          <h1 className="text-base font-semibold text-gray-900 truncate leading-tight">
            {pageTitle}
          </h1>
          {appName ? (
            <p className="text-xs text-gray-500 truncate leading-tight mt-0.5">
              {appName}
            </p>
          ) : null}
        </div>
        <div className="w-9 shrink-0" aria-hidden="true" />
      </div>
    </div>
  );
}

export function DashboardLayout() {
  const location = useLocation();
  const [chatOpen, setChatOpen] = useState(false);

  const app = getAppFromPathname(location.pathname);

  if (!app) {
    return <NotFound />;
  }

  return (
    <SidebarProvider defaultExpanded={true}>
      <div
        style={{ height: "100vh" }}
        className="min-h-screen w-full flex bg-gray-50"
      >
        <MobileHeader />
        <UnifiedSidebar app={app} />
        <div
          style={{
            height: "100vh",
            overflow: "auto",
            transition: "margin-right 0.3s",
            marginRight: chatOpen ? SIDEBAR_WIDTH : 0,
          }}
          className="flex-1 p-5 lg:p-7 pt-16 lg:pt-5"
        >
          <Outlet />
        </div>
        <AIChatAgent open={chatOpen} onOpenChange={setChatOpen} />
      </div>
    </SidebarProvider>
  );
}
